module.exports = __webpack_public_path__ + "img/full5-min.b93a1e28.png";